import React, { useState } from 'react';
import { colors, markedDmcaCountLables } from '../../config/constants';
import { columnKeyword } from '../../config/keyword';
import { KeywordJobStatus, Role } from '../../config/enum';
import { StateProps } from '../../redux/reducer';
import { useSelector } from 'react-redux';

export interface Column {
  id: string | number;
  label: string;
  minWidth?: number;
  align?: string;
}
interface ViewDataProps {
  value: string | number | boolean | null;
  column: Column;
  row: any;
  showView: boolean;
  showEdit: boolean;
  showDelete: boolean;
  onViewHandler?: (arg: string | number) => void;
  onDeleteHandler?: (arg: string | number) => void;
  onEditHanlder?: (arg: string | number) => void;
  onSrcFileDownload?: (arg: string | number) => void;
  onErrFileDownload?: (arg: string | number) => void;
  onMarkForArchived?: (arg: string | number) => void;
}

export const ViewData = (props: ViewDataProps) => {
  const {
    value,
    column,
    row,
    showView,
    showEdit,
    showDelete,
    onViewHandler,
    onEditHanlder,
    onDeleteHandler,
    onSrcFileDownload,
    onErrFileDownload,
    onMarkForArchived,
  } = props;
  const userInfo = useSelector((state: StateProps) => state.tokenInfo.userInfo);
  const dateArray: string[] = ['createdDate', 'startDate', 'endDate'];
  const [copyToast, setCopyToast] = useState(false);

  const handleCopyPaste = () => {
    navigator.clipboard.writeText(row.weblinkUrl);
    setCopyToast(true);
    setTimeout(() => {
      setCopyToast(false);
    }, 1000);
  };

  switch (column.id) {
    case columnKeyword.SITE_STATUS:
      return (
        <div
          className={`font-semibold text-[13px] py-2 ${
            value === 'New Site'
              ? 'text-green-500'
              : value === 'Recrawl'
              ? 'text-orange-500'
              : value === 'Crawling' ||
                value === 'Indexing' ||
                value === 'HitCounting'
              ? 'text-blue-500'
              : value === 'Terminated'
              ? 'text-red-500'
              : 'text-black'
          } `}
        >
          {value}
        </div>
      );

    case 'weblinkUrl':
      return (
        <div className="py-2">
          {' '}
          <a
            className={`${colors.tableText} text-blue-600 py-1`}
            href={`${row.weblinkUrl}`}
            target="_blank"
            rel="noreferrer"
          >
            {value}
          </a>
        </div>
      );

    case columnKeyword.COPY_OPEN:
      return (
        <div
          className={`w-[${column.minWidth}px] flex items-center justify-center space-x-6`}
        >
          <div onClick={() => handleCopyPaste()} className="relative">
            <i className="fa-solid fa-clipboard text-[14px] cursor-pointer text-[blue]"></i>
            <div className="absolute top-[-8px] bg-white">
              {copyToast && (
                <div className={`text-[green] text-sm px-2 py-1 border`}>
                  Copied!
                </div>
              )}
            </div>
          </div>
          <a href={`${row.weblinkUrl}`} target="_blank" rel="noreferrer">
            <i className="fa-solid fa-up-right-from-square text-[14px] cursor-pointer text-[#f8854f]"></i>
          </a>
        </div>
      );
    case columnKeyword.KEYWORD_TEXT:
      return (
        <div>
          {row.isDeleted ? (
            <div className="text-[13px] py-2">
              {value}{' '}
              <span className="text-[red] italic font-semibold">{`${' - (Deleted)'}`}</span>
            </div>
          ) : (
            <div className="text-[13px] py-2">{value}</div>
          )}
        </div>
      );

    case columnKeyword.KEYWORD_ACTON:
      return (
        <div className="flex items-center justify-end space-x-2 mr-4">
          {showView && !row.isDeleted ? (
            <div
              data-testid="showView-Wrapper"
              onClick={() => onViewHandler && onViewHandler(row)}
              className={`px-2 py-1 cursor-pointer rounded-sm`}
            >
              <i className="fa-solid fa-eye text-lg text-[green]"></i>
            </div>
          ) : (
            <div className={`h-10 `}>{/*Empty div*/}</div>
          )}{' '}
        </div>
      );
    case columnKeyword.CATEGORY_NAME:
      return (
        <div>
          {row.isDeleted ? (
            <div className=" text-[13px]">
              {value}{' '}
              <span className="text-[red] italic font-semibold">{`${' - (Deleted)'}`}</span>
            </div>
          ) : row.isActive === false ? (
            <div className=" text-[13px]">
              {value}{' '}
              <span className="text-[red] italic font-semibold">{`${' - (Deactivated)'}`}</span>
            </div>
          ) : (
            <div className="text-[13px]">{value}</div>
          )}
        </div>
      );
    case columnKeyword.CATEGORY_ACTION:
      return (
        <div className="flex items-center justify-end space-x-2 mr-4">
          {showView && !row.isDeleted && row.isActive ? (
            <div
              data-testid="showView-Wrapper"
              onClick={() => onViewHandler && onViewHandler(row)}
              className={`px-2 py-1 cursor-pointer rounded-sm`}
            >
              <i className="fa-solid fa-eye text-lg text-[green]"></i>
            </div>
          ) : (
            <div className={`h-10 `}>{/*Empty div*/}</div>
          )}{' '}
        </div>
      );
    case columnKeyword.NOISE_ACTION:
      return (
        <div className="flex items-center justify-end space-x-2 mr-4">
          {(showView && !row.isMasterData && row.text) ||
          userInfo.role === Role.SuperAdmin ? (
            <div
              data-testid="showView-Wrapper"
              onClick={() => onViewHandler && onViewHandler(row)}
              className={`px-2 py-1 cursor-pointer rounded-sm`}
            >
              <i className="fa-solid fa-eye text-lg text-[green]"></i>
            </div>
          ) : (
            <div className={`h-10 `}>{/*Empty div*/}</div>
          )}
        </div>
      );
    case columnKeyword.ACTION:
      return (
        <div className="flex items-center justify-end space-x-2 mr-4  ">
          {showView && (
            <div
              data-testid="showView-Wrapper"
              onClick={() => onViewHandler && onViewHandler(row)}
              className={`px-2 py-1 cursor-pointer rounded-sm`}
            >
              <i className="fa-solid fa-eye text-lg text-[green]"></i>
            </div>
          )}

          {showEdit && (
            <div
              data-testid="showEdit-Wrapper"
              onClick={() => onEditHanlder && onEditHanlder(row)}
              className={`px-2 py-1 cursor-pointer rounded-sm`}
            >
              <i className="fa-solid fa-pencil text-lg text-[blue]"></i>
            </div>
          )}
          {showDelete && (
            <div
              data-testid="showDelete-Wrapper"
              onClick={() => onDeleteHandler && onDeleteHandler(row)}
              className={`px-2 py-1 cursor-pointer rounded-sm`}
            >
              <i className="fa-solid fa-trash-can text-lg text-[red]"></i>{' '}
            </div>
          )}
        </div>
      );

    case columnKeyword.GENERATED_DMCA:
      return (
        <div className="w-[200px] flex items-center justify-center">
          {value && (
            <i
              data-testid="generated-true"
              className="fa-solid fa-circle-check text-lg font-semibold text-[green]"
            ></i>
          )}
          {!value && (
            <i
              data-testid="generated-false"
              className="fa-solid fa-circle-xmark text-lg font-semibold text-[red]"
            ></i>
          )}
        </div>
      );
    case columnKeyword.REVIEWED:
      return (
        <div
          data-testid="review-wrapper"
          className="w-[100px] flex items-center justify-center"
        >
          {value && (
            <i className="fa-solid fa-circle-check text-lg font-semibold text-[green]"></i>
          )}
          {!value && (
            <i className="fa-solid fa-circle-xmark text-lg font-semibold text-[red]"></i>
          )}
        </div>
      );
    case columnKeyword.REVIEW_STATUS:
      return (
        <div
          data-testid="review-parcentage"
          className="mt-1 flex items-center space-x-2"
        >
          <div className="h-4 w-[150px] border ">
            <div
              style={{ width: `${row.reviewPercentage * 1.5}px` }}
              className={`h-4 bg-green-600 `}
            ></div>
          </div>
          <div>{Math.round(row.reviewPercentage)}% </div>
        </div>
      );

    case columnKeyword.MARK_FOR_ARCHIVE:
      if (row.isDmcaGenerated === true && row.isArchive === false) {
        return (
          <div
            data-testid="mark-archived-wrapper-true"
            onClick={() => onMarkForArchived && onMarkForArchived(row)}
            className="w-[80px] flex items-center justify-center bg-yellow-400 px-2 py-1 font-semibold rounded-sm shadow-md cursor-pointer mx-2"
          >
            <div>Archive</div>
          </div>
        );
      } else {
        return (
          <div
            data-testid="mark-archived-wrapper-false"
            className="w-[120px] flex items-center justify-center px-4 py-1 font-semibold rounded-full"
          >
            <div>-</div>
          </div>
        );
      }

    case columnKeyword.MARK_YOUR_PREFERENCE:
      return (
        <div
          data-testid="mark-preference-wrapper"
          className="flex flex-col items-end justify-end pr-10 "
        >
          <div className="h-8 w-48 border rounded-full flex items-center justify-between shadow-sm px-2 mb-1">
            <div className="h-4 w-4 bg-[red] rounded-full "></div>
            <div className="font-semibold text-[#1a1824]">
              {markedDmcaCountLables.markedDMCA}
            </div>
            <div className="cursor-pointer mt-2 ">
              <input
                type="checkbox"
                name="allSelect"
                className="w-4 h-4 cursor-pointer"
              />
            </div>
          </div>
          <div className="h-8 w-48 border rounded-full flex items-center justify-between shadow-sm px-2 mb-1">
            <div className="h-4 w-4 bg-[orange] rounded-full "></div>
            <div className="font-semibold text-[#1a1824]">
              {markedDmcaCountLables.markedRevisit}
            </div>
            <div className="cursor-pointer mt-2 ">
              <input
                type="checkbox"
                name="allSelect"
                className="w-4 h-4 cursor-pointer"
              />
            </div>
          </div>
          <div className="h-8 w-48 border rounded-full flex items-center justify-between shadow-sm px-2">
            <div className="h-4 w-4 bg-[green] rounded-full "></div>
            <div className="font-semibold text-[#1a1824]">
              {markedDmcaCountLables.ignored}
            </div>
            <div className="cursor-pointer mt-2 ">
              <input
                type="checkbox"
                name="allSelect"
                className="w-4 h-4 cursor-pointer"
              />
            </div>
          </div>
        </div>
      );
    case columnKeyword.STATUS:
      if (value === KeywordJobStatus.Pending) {
        return (
          <div
            data-testid="status-pending"
            className="flex items-center space-x-2 w-[100px] text-[14px] text-[#324968]  "
          >
            <i className="fa-regular fa-clock  text-yellow-500"></i>
            <div
              className={`${colors.primaryText} text-[13px] text-[#272e36] font-medium `}
            >
              Pending
            </div>
          </div>
        );
      } else if (value === KeywordJobStatus.Completed) {
        return (
          <div
            data-testid="status-completed"
            className="flex items-center space-x-2 w-[100px]"
          >
            <i className="fa-solid fa-circle-check  text-green-500"></i>
            <div
              className={`${colors.primaryText} text-[13px] text-[#272e36] font-medium `}
            >
              Completed
            </div>
          </div>
        );
      } else if (value === KeywordJobStatus.Error) {
        return (
          <div
            data-testid="status-error"
            className="flex items-center space-x-2 w-[100px]"
          >
            <i className="fa-solid fa-circle-xmark  text-red-500"></i>
            <div
              className={`${colors.primaryText} text-[13px] text-[#272e36] font-medium `}
            >
              Error
            </div>
          </div>
        );
      } else {
        return <div data-testid="no-status">No information</div>;
      }
    case columnKeyword.SRC_DOWNLOAD:
      if (row.documentsStoreId !== null) {
        return (
          <div
            data-testid="src-download-wrapper"
            className={`w-[${column.minWidth}px]`}
            onClick={() => onSrcFileDownload && onSrcFileDownload(row)}
          >
            <div className="cursor-pointer">
              <i className="fa-solid fa-cloud-arrow-down text-[green] text-[20px]"></i>
            </div>
          </div>
        );
      } else {
        return (
          <div data-testid="err-download" className={`w-[${column.minWidth}px]`}>
            <div>-</div>
          </div>
        );
      }

    case columnKeyword.ERR_DOWNLOAD:
      if (row.errorDocumentsStoreId === null) {
        return (
          <div data-testid="err-download" className={`w-[${column.minWidth}px]`}>
            <div>-</div>
          </div>
        );
      } else {
        return (
          <div
            data-testid="err-download"
            className={`w-[${column.minWidth}px]`}
            onClick={() => onErrFileDownload && onErrFileDownload(row)}
          >
            <div className="cursor-pointer">
              <i className="fa-solid fa-cloud-arrow-down text-[red] text-[20px]"></i>
            </div>
          </div>
        );
      }

    default:
      if (typeof value === columnKeyword.NUMBER) {
        return (
          <div
            data-testid="number-wrapper"
            className={`${colors.tableText} w-[${column.minWidth}px]`}
          >
            <div> {value}</div>
          </div>
        );
      } else {
        if (dateArray.includes(column.id as string)) {
          return (
            <div
              data-testid="date-wrapper"
              className={`${colors.tableText} w-[${column.minWidth}px] `}
            >
              {value?.toString().substring(0, 10)}
            </div>
          );
        } else if (value === null || value === '') {
          return (
            <div data-testid={'null-wrapper'} className={colors.tableText}>
              {'-'}
            </div>
          );
        } else {
          return <div className={colors.tableText}>{value}</div>;
        }
      }
  }
};

export default ViewData;
